import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
//import { firebaseApp } from './firebaseDb'
import './registerServiceWorker'
//import firebase from 'firebase/compat/app'
//import { version } from '../package'

Vue.config.productionTip = false



// Import Bootstrap and BootstrapVue CSS files (order is important)
import './assets/styles/app.scss'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)



new Vue({
  render: h => h(App)
}).$mount('#app')
